
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { HarvestFormValues } from './schema';

interface QualitySectionProps {
  form: UseFormReturn<HarvestFormValues>;
}

const QualitySection: React.FC<QualitySectionProps> = ({ form }) => {
  const status = form.watch('status');
  
  if (status !== 'completed') {
    return null;
  }
  
  return (
    <FormField
      control={form.control}
      name="quality_grade"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Quality Grade</FormLabel>
          <Select 
            disabled={form.formState.isSubmitting} 
            onValueChange={field.onChange} 
            defaultValue={field.value || "ungraded"}
            value={field.value || "ungraded"}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select quality grade" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="ungraded">Not Graded</SelectItem>
              <SelectItem value="A">A (Excellent)</SelectItem>
              <SelectItem value="B">B (Good)</SelectItem>
              <SelectItem value="C">C (Average)</SelectItem>
              <SelectItem value="D">D (Poor)</SelectItem>
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default QualitySection;
